import { Card, Text, vars } from '@etg/wings';
import { css } from '@eti/styles';
import type { FareRulesType } from '../../models';
import TitledCard from '../../../../common/components/TitledCard';

const fareRuleStyles = css`
  font-family: ${vars.font.body};
  font-size: 0.875rem;
  white-space: pre-wrap;
`;

interface FareRulesDrawerContentProps {
  fareRulesDescription?: string | null;
  fareRules: FareRulesType;
}

const FareRulesDrawerContent = ({
  fareRulesDescription,
  fareRules,
}: FareRulesDrawerContentProps) => {
  return (
    <>
      {fareRulesDescription && (
        <Card data-testid="fare-rule-description">
          <Text asHtml>{fareRulesDescription}</Text>
        </Card>
      )}
      {fareRules &&
        fareRules.length > 0 &&
        fareRules.map((rule, index) => {
          if (rule && rule.header) {
            return (
              <TitledCard
                headingAs="h3"
                headingLevel={4}
                key={`rule-${index}`}
                title={rule?.header}
              >
                <Text asHtml className={fareRuleStyles}>
                  {rule?.content}
                </Text>
              </TitledCard>
            );
          }
          return null;
        })}
    </>
  );
};

export default FareRulesDrawerContent;
